import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  addDIDCountryToList,
  getAllDIDCountriesList,
} from '../../api-services';
import swal from 'sweetalert';
import { useEffect } from 'react';

const initialState = {
  country: '',
};

const AddDidCountry = ({
  setOpenModal,
  openModal,
  editData = {},
  setEditData,
}) => {
  const [initialValues, setInitialValues] = useState(initialState);
  const isEdit = editData && Object.keys(editData).length > 0;
  const queryClient = useQueryClient();

  const { data: cityList, isLoading: citiListLoading } = useQuery(
    'getAllDIDCountriesList',
    getAllDIDCountriesList,
    {
      select: (data) => data?.data?.data,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      const { did_number, city_id } = editData;
      setInitialValues({ did_number, city_id });
    }
  }, [editData]);

  const { mutateAsync, isLoading } = useMutation(
    'addDIDCountryToList',
    (payload) => addDIDCountryToList(payload),
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('Alldidcountries');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );
  // const { mutateAsync: mutateAsyncUpdate, isLoading: isUpdating } = useMutation(
  //   'franceUpdate',
  //   (payload) => franceUpdate(payload),
  //   {
  //     onSuccess: (data) => {
  //       swal({
  //         text: data?.data?.message ?? 'Success!',
  //         icon: 'success',
  //         type: 'success',
  //         timer: 2000,
  //       }).then(() => {
  //         queryClient.invalidateQueries('franceList');
  //         handleClose();
  //       });
  //     },
  //     onError: (error) => {
  //       swal({
  //         title: error?.response?.data?.message,
  //         type: 'danger',
  //         icon: 'error',
  //       });
  //     },
  //   },
  // );

  const validationSchema = Yup.object().shape({
    country: Yup.string().required('Country is required'),
  });

  const handleSubmitForm = async (values) => {
    const { country } = values;
    await mutateAsync({ name: country });
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const handleClose = () => {
    setEditData({});
    formik.resetForm();
    setOpenModal(false);
  };

  return (
    <Modal
      size="md"
      centered
      show={openModal}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            Add DID Country
          </h5>
        </div>

        <div className="modal-body">
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <select
                className="form-control"
                name="country"
                disabled={citiListLoading}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.country}
              >
                <option value="">Please select country</option>
                {cityList &&
                  cityList.length > 0 &&
                  cityList.map(({ iso, name }) => (
                    <option value={name} key={iso}>
                      {name}
                    </option>
                  ))}
              </select>
              {formik.touched.country && formik.errors.country ? (
                <div className="error_required">{formik.errors.country}</div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            disabled={isLoading}
            onClick={() => handleClose()}
          >
            Close
          </button>

          <button
            type="submit"
            className="btn btn-dark-blue"
            disabled={isLoading}
          >
            {isLoading ? 'Please wait...' : `${isEdit ? 'Update' : 'Add'}`}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddDidCountry;
